import { Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * POM-6279 — the operator's statement that they PHONED the pharmacy, as a checkbox the fax
 * dialogs gate their confirm button on.
 *
 * A FAX CANNOT BE RECALLED. Resending one the pharmacy already holds can fill the prescription
 * twice, and reconciling one it never received leaves the patient with nothing — the system cannot
 * tell which, only a phone call can. So the button that acts on the answer stays disabled until the
 * operator has said, in these words, what the pharmacy told them.
 */
const RelayFaxPhoneConfirmation = ({ id, checked, onChange, label }) => (
  <FormControlLabel
    sx={{ mt: 2, alignItems: 'flex-start' }}
    control={
      <Checkbox
        id={id}
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        sx={{ pt: 0.25 }}
      />
    }
    label={label}
  />
);

RelayFaxPhoneConfirmation.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default RelayFaxPhoneConfirmation;
